export default function(str) {
  let word = null;
  if (str) {
    const firstLetter = [...str][0].toUpperCase();
    const restLetters = str.slice(1).toLowerCase();
    word = `${firstLetter}${restLetters}`;
  }
  return word;
}
